/** Os termos de uso (`tos.*`): o cadastro e o rodapé do site (docs/spec/landing.md) abrem o mesmo diálogo. */
import { useT } from '../i18n/index.js';
import { Button, Dialog } from '../ui/controls.js';

export function TermsDialog({ onClose }: { onClose: () => void }) {
  const t = useT();
  return (
    <Dialog
      title={t('tos.title')}
      onClose={onClose}
      actions={
        <Button variant="action" onClick={onClose}>
          {t('common.close')}
        </Button>
      }
    >
      {t('tos.text')}
    </Dialog>
  );
}
